import {
  Dispatch,
  Reducer,
  ReducerState,
  useCallback,
  useRef,
  useState
} from 'react';

/**
 * Custom reducer for state management with Redux Reducers
 *
 * TODO: add Redux WebTools support
 * TODO: Todo investigate if the existing React useReducer method can be safely used instead of this function
 * @param reducer
 * @param initialState
 * @returns
 */
export function useReducer<R extends Reducer<any, any>>(
  reducer: R,
  initialState: ReducerState<R>
): [ReducerState<R>, Dispatch<any>] {
  const stateRef = useRef<ReducerState<R>>(initialState);
  const [, setState] = useState(stateRef.current);

  const customDispatch = useCallback(
    (action: any) => {
      if (typeof action === 'function') {
        action(customDispatch, () => stateRef.current);
        return;
      }

      stateRef.current = reducer(stateRef.current, action);
      setState(stateRef.current);
    },
    [reducer]
  );

  return [stateRef.current, customDispatch];
}
